import { render, staticRenderFns } from "./shop.vue?vue&type=template&id=46aec55e&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"
import style0 from "./shop.vue?vue&type=style&index=0&id=46aec55e&prod&lang=scss&scoped=true"
import style1 from "./shop.vue?vue&type=style&index=1&id=46aec55e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aec55e",
  null
  
)

export default component.exports